import { observable } from "@chorda/core";
import { Button, Image, Modal, RowLayout } from "chorda-bulma";
import { IMAGE_1 } from "../../data";
const isOpened = observable(false);
export default () => {
    return RowLayout([
        Button({
            text: 'Open modal image',
            onClick: () => {
                isOpened.$value = !isOpened.$value;
            }
        }),
        Modal({
            content: Image({
                url: IMAGE_1
            }),
            active$: () => isOpened
        })
    ]);
};
